export enum UserGroups {
  AGENCY_ADMIN = "vcc-agency-user-admin",
  INC_CONTRIBUTOR = "vcc-inc-contrib",
  INC_MANAGER = "vcc-inc-mgr",
  INC_RECORDS_MANAGER = "vcc-records-mgr",
  MAJOR_EVENT_CONTRIBUTOR = "vcc-major-event-contrib",
  PIO = "vcc-inc-pio",
  SITE_ADMIN = "vcc-site-admin",
  VCC_BASIC = "vcc-basic",
}

export enum UserGroupLabel {
  AGENCY_ADMIN = "Agency User Administrator",
  INC_CONTRIBUTOR = "Incident Contributor",
  INC_MANAGER = "Incident Manager",
  INC_RECORDS_MANAGER = "Incident Records Manager",
  MAJOR_EVENT_CONTRIBUTOR = "Major Event Contributor",
  PIO = "Public Information Officer",
  SITE_ADMIN = "Site Administrator",
  VCC_BASIC = "Basic User",
}

export enum UserGroupDescription {
  AGENCY_ADMIN = "Allows users to view Admin page, add and edit any user, and update user roles.",
  INC_CONTRIBUTOR = "Allows user to add notes to Incident Models.",
  INC_MANAGER = "Allows users to create, edit, and close incidents, and create and edit mobility strategies. Allows for viewing and re-opening closed incidents, but not deleted incidents. If a user is set as an Incident Manager, they should also be set as an Incident Contributor as well.",
  INC_RECORDS_MANAGER = "Allows users to view Incident Model Records Management page, to view and finalize reports.",
  MAJOR_EVENT_CONTRIBUTOR = "Allows users to create, edit, and delete Major Construction and Event records.",
  PIO = "Allows users to create, edit, close Public Information Officer actions Recommended to set PIO's as Incident Managers as well.",
  SITE_ADMIN = "Allows users full admin abilities, including view Admin page, add and edit any user, and update user roles.",
  VCC_BASIC = "Allows viewing dashboard, feed, collaboration spaces, and open incident models pages. Also allows viewing all map layers, details of other users, and all notifications. Allows updating the user's own profile and notification preferences.",
}